export const parseOccupancy = occupancy => {
  if (Number.isFinite(occupancy)) {
    return {
      adults: occupancy,
    };
  }

  if (typeof occupancy !== 'string') {
    return {};
  }

  const openRoundBracketIndex = occupancy.indexOf('(');
  const closeRoundBracketIndex = occupancy.indexOf(')');
  const openSquareBracketIndex = occupancy.indexOf('[');
  const closeSquareBracketIndex = occupancy.indexOf(']');
  const hasChildren = openRoundBracketIndex !== -1;
  const hasInfants = openSquareBracketIndex !== -1;

  const getKids = (openBracketIndex, closeBracketIndex) => {
    return occupancy
      .substring(openBracketIndex + 1, closeBracketIndex)
      .split(',')
      .filter(Boolean)
      .map(Number);
  };

  const guests = {
    adults: Number(
      occupancy.substring(
        0,
        hasChildren
          ? openRoundBracketIndex
          : hasInfants
          ? openSquareBracketIndex
          : occupancy.length
      )
    ),
  };

  const children =
    hasChildren && getKids(openRoundBracketIndex, closeRoundBracketIndex);
  if (children && children.length > 0) {
    guests.children = children;
  }

  const infants =
    hasInfants && getKids(openSquareBracketIndex, closeSquareBracketIndex);
  if (infants && infants.length > 0) {
    guests.infants = infants;
  }

  return guests;
};

export const parseOccupancies = occupancy => {
  let guests = { adults: 0, children: [], infants: [] };
  occupancy.forEach(item => {
    const { adults = 0, children = [], infants = [] } = parseOccupancy(item);
    guests = {
      adults: guests.adults + adults,
      children: [...guests.children, ...children],
      infants: [...guests.infants, ...infants],
    };
  });
  return guests;
};

const parseGuest = (guest = '') =>
  typeof guest !== 'string' ? [] : guest.split(',').filter(Boolean);

export const transformGuestsToOccupancy = (adult, children) => {
  const occupancy = parseGuest(adult);
  const childrenMap = parseGuest(children).reduce((room, value) => {
    const [roomNo, childAge] = value.trim().split('_');

    if (room[roomNo]) {
      room[roomNo] = `${room[roomNo]},${childAge}`;
    } else {
      room[roomNo] = childAge;
    }

    return room;
  }, {});

  Object.keys(childrenMap).forEach(roomNo => {
    const roomIndex = roomNo - 1;
    if (!occupancy[roomIndex]) return;

    occupancy[roomIndex] = `${occupancy[roomIndex]}(${childrenMap[roomNo]})`;
  });

  return occupancy;
};

export const getRoomCount = occupancy => {
  return Array.isArray(occupancy) ? occupancy.length : 1;
};
